import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const TABS = [
  { key: "overview", label: "Overview" },
  { key: "attributes", label: "Gemstone Attributes" },
  { key: "commercial", label: "Price & Demand" },
  { key: "trend", label: "Click Trends" },
];

const ReportTabs = ({ overview, attributes, commercial, trend }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("overview");

  const panes = { overview, attributes, commercial, trend };

  return (
    <React.Fragment>
      <div className="edr-tabs">
        {TABS.map((tab) => (
          <div
            key={tab.key}
            className={`edr-tab${activeTab === tab.key ? " edr-active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {t(tab.label)}
          </div>
        ))}
      </div>
      <div className="row">{panes[activeTab]}</div>
    </React.Fragment>
  );
};

export default ReportTabs;
